module.exports = __webpack_public_path__ + "static/media/15a.dc1e4409.jpeg";